import { EmployeeJob } from './EmployeeJob';
import { LaborScheduleEntry } from './LaborScheduleEntry';
import { ManualTipShare } from './ManualTipShares';
import { Store } from './Store';
import { TimeCard } from './TimeCard';
import { TimecardHistory } from './TimecardHistory';
import { TipGroupJob } from './TipGroupJob';

export class Job {
	id: number;
	name: string;
	externalId: string;
	schedulingId: string;
	laborGroup: LaborGroup;

	venueKey: number;
	ID: number;
	Name: string;
	LaborGroupID: number;
	ExternalID: string;
	HotSchedulesID: string;
	ScheduleID: string;

	EmployeeJobs: EmployeeJob[];

	TimeCards: TimeCard[];

	TimecardHistory: TimecardHistory[];

	PayerManualTipShare: ManualTipShare[];

	ReceiverManualTipShare: ManualTipShare[];

	TipGroupJob: TipGroupJob[];

	LaborScheduleEntry: LaborScheduleEntry[];

	stores: Store;

	public constructor(init?: Partial<Job>) {
		Object.assign(this, init);
	}
}

export interface LaborGroup {
	name: string;
	id: string;
}
